module.exports = __webpack_public_path__ + "media/images/vp/icon.copy-54d2ab50fbd77adfd7e2aab1aab8b1a9.svg";